class Meta {
  private readonly BASE_URL = 'https://www.martinthierry.info';

  updateCanonicalUrl(path: string): void {
    // Nettoyer le chemin pour éviter les doubles slashes
    const cleanPath = path === '/' ? '' : path;
    const canonicalUrl = `${this.BASE_URL}${cleanPath}`;

    // Supprimer l'ancienne balise canonique
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }

    // Créer la nouvelle balise canonique
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = canonicalUrl;
    document.head.appendChild(canonical);
  }
}

export default Meta;
